export default __webpack_public_path__ + "static/media/instagram.06a167ff.svg";